import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import ChElements from "../ui/ch_elements/ChElements";
import ChElementsList from "../ui/ch_elements/ChElementsList";
import ChElementDetails from "../ui/ch_elements/ChElementDetails";
import ChElementAddEdit from "../ui/ch_elements/ChElementsAddEdit";
import AnnexDataAddEdit from "../ui/annexdata/AnnexDataAddEdit";
import E3dAddEdit from "../ui/e3ds/E3dAddEdit";
import AnnexDataChemiTools from "../ui/annexdata/AnnexDataChemiTools";
import SpecialistRequired from "../ui/ch_elements/SpecialistRequired";

const ChElementsRoutes = (
  <Route
    path={AppSections.CHELEMENTS}
    element={
      <ProtectedRoute>
        <ChElements />
      </ProtectedRoute>
    }
  >
    <Route path="/chelements/" element={<ChElementsList />} />
    <Route path="create-restricted" element={<SpecialistRequired />} />
    <Route path="create" element={<ChElementAddEdit />} />
    <Route path=":id/view" element={<ChElementDetails />} />
    <Route path=":id/edit" element={<ChElementAddEdit />} />

    {/* e3ds routes */}
    <Route path=":chid/e3ds/create" element={<E3dAddEdit />} />

    {/* documents routes */}
    <Route path=":chid/annexdata/create" element={<AnnexDataAddEdit />} />
    {/* dedicated route for ChemiTools to display the documents list */}
    <Route path=":chid/annexdata" element={<AnnexDataChemiTools />} />
  </Route>
);

export default ChElementsRoutes;
